var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6591 15.726C13.1571 17.0113 11.2088 17.7872 9.07991 17.7872C4.32949 17.7872 0.478516 13.924 0.478516 9.15851C0.478516 4.39301 4.32949 0.529785 9.07991 0.529785C11.2091 0.529785 13.1576 1.30589 14.6597 2.59148C16.1616 1.30618 18.1099 0.530273 20.2388 0.530273C24.9893 0.530273 28.8402 4.39349 28.8402 9.15901C28.8402 13.9245 24.9893 17.7877 20.2388 17.7877C18.1096 17.7877 16.1611 17.0116 14.6591 15.726Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6602 15.7269C16.5096 14.1443 17.6823 11.7893 17.6823 9.1595C17.6823 6.52972 16.5096 4.17473 14.6602 2.59206C16.1621 1.3067 18.1105 0.530762 20.2394 0.530762C24.9899 0.530762 28.8408 4.39398 28.8408 9.1595C28.8408 13.925 24.9899 17.7882 20.2394 17.7882C18.1105 17.7882 16.1621 17.0123 14.6602 15.7269Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6597 15.7264C16.5091 14.1437 17.6818 11.7888 17.6818 9.15901C17.6818 6.52927 16.5091 4.17429 14.6597 2.59161C12.8104 4.17429 11.6377 6.52927 11.6377 9.15901C11.6377 11.7888 12.8104 14.1437 14.6597 15.7264Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.aebc584642e8092418c7aa4efcd289b3.svg";
export { ForwardRef as ReactComponent };